import { render, staticRenderFns } from "./articleHtml.vue?vue&type=template&id=2a403a63&"
import script from "./articleHtml.vue?vue&type=script&lang=js&"
export * from "./articleHtml.vue?vue&type=script&lang=js&"
import style0 from "./articleHtml.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports